import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import CategoryForm from '../CategoryForm/CategoryForm';

const CategoryModal = ({ toggle, isOpen, className, type, activeCategory }) => (
  <Modal isOpen={isOpen} toggle={toggle} className={className}>
    <ModalHeader>
      Add new{' '}
      {type === 'category' ? <span>category</span> : <span>subcategory</span>}
    </ModalHeader>
    <ModalBody>
      <CategoryForm
        toggle={toggle}
        activeCategory={activeCategory}
        type={type}
      />
    </ModalBody>
  </Modal>
);

export default CategoryModal;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryModal/CategoryModal.js